import "./BSpinner.css";

function BSpinner() {
  return (
    <div className="spinner-body">
      <div id="spinner"></div>
    </div>
  );
}

export default BSpinner;
